import { Component, OnInit,
  NgModule,
  OnDestroy,
  EventEmitter,
  Input,
  Output,
  ViewContainerRef,
  OnChanges,
  TemplateRef,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
} from '@angular/core';

import { fromEvent } from 'rxjs/internal/observable/fromEvent';
// import { saveDocument } from '../assets/js/textcontrol.js';
// import { saveDocument, loadDocument } from '../assets/js/custom.js';
declare const saveDocument: any;
declare const loadDocument: any;
declare const TXTextControl: any;
import { Inject } from '@angular/core';



declare const MyTokem = 'Wexrf2EDhT9MxNwTgzaN';


// Comms
import { DemoService } from './../demo.service';
import { Routes, RouterModule, Router } from '@angular/router';
import { MysqlService } from './../services/mysql.service';
// view iframes
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SystemFile } from './../shared/models/file.model'; // file model

import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Location } from '@angular/common';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { Observable, Subject, map, throwError ,  Subscription } from 'rxjs';

// 


// import { FileUploaderService } from './../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'

import { SubjectCommunication } from './../shared/models/subjectCommunication.model';
import { SubjectCommunicationAttatchments } from './../shared/models/subjectCommunicationAttachments.model';


 import * as $ from 'jquery';
// see: https://www.youtube.com/watch?v=YPBcy6LSxsg

import {
  MultiSelectComponent,
  DropDownListComponent,
} from '@syncfusion/ej2-angular-dropdowns';


import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection,
} from '@syncfusion/ej2-angular-richtexteditor';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { GlobalFunctionsService } from './../services/global-functions.service';
import { Thickness } from '@syncfusion/ej2-angular-charts';
import { LegalDateTimeService } from './../services/legal-datetime.service';


@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ToolbarService,
    LinkService,
    ImageService,
    HtmlEditorService,
    MultiSelectComponent,
    DropDownListComponent,
  ]
})
export class CommunicationComponent implements OnInit {


  accessToken: string = '12388-22132-12133';

//   onClickSave() {
//     saveDocument();
// }
  title?: any;
  username = "tsa-textControlvBeta";
  place = "pune";
  date = "29-06-1989";
  isUserNameFieldExist = false;
  editor = false;
f_subject_number = '1001.1.1.10';

job_plaintiff_name = "Nick Bowen";
subject_1_name = "Samy Newman";
job_document_number = '1.0.0.1';

  placeholders = ["username", "date", "place", "job_plaintiff_name", "subject_1_name", "job_document_number" ];
  formField: any;
  new_placeholder?: string | any;






  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
  subject_id?: number;
  job_status_run?: any;
  subject_notes?: any;
  subjects?: any;
  public who;

  bsModalRef!: BsModalRef;
  // MODAL
  modalRef!: BsModalRef;
  subject_com_types?: any;

  feature = 'Feature 1';
  selectedFeatures: any = [];
  selectedFeaturesJobFiles: any = [];

  allAttachedFiles: any = [];
  allEmailRecipients: any = [];
  allClientEmailRecipients: any = [];
  allLoginEmailRecipients: any = [];
  allClientInvoiceEmailRecipients: any = [];

  // allAttachments: any[] = [];

  // allAttachments: any[] = [];

  allAttachments: any[] = [];
  allRecipients: any[] = [];

  // as an angular object / model
  /* allAttachments: any = {
  file_name: 'testfilename.file',
  job_file: 0 ,
  subject_file: 0,
}; */
  empList: Array<any> = [];

  modelds: any;

  public placeholder: String = 'All Recipients';

  // toggle elements
  isShow = true;
  isShow_uploaded = true;

  email_template_directory = this.gfunc.baseUploadURLEmailTemplatesNOHTTP;


  public today = Date.now();
  // variables for richtexteditor as form
  @ViewChild('fromRTE') rteEle?: RichTextEditorComponent;

  public tools: object = {
    items: [
      'Undo',
      'Redo',
      '|',
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      '|',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      '|',
      'SubScript',
      'SuperScript',
      '|',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      '|',
      'OrderedList',
      'UnorderedList',
      '|',
      'Indent',
      'Outdent',
      '|',
      'CreateLink',
      'Image',
      '|',
      'ClearFormat',
      'Print',
      'SourceCode',
      '|',
      'FullScreen',
    ],
  };

  // demo data
  document_types: any[] = [
    {
      document_id: '1',
      document_type_id: '1',
      document_name: 'Process Instructions',
      document_description: '',
      document_template_file: 'template.docx',
      name_file: 'PS_Instructions',
    },
    {
      document_id: '2',
      document_type_id: '1',
      document_name: 'Process Instructions Combined',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'PSC_Instructions',
    },
    {
      document_id: '3',
      document_type_id: '1',
      document_name: 'Field Call Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'FC_Instructions',
    },
    {
      document_id: '4',
      document_type_id: '1',
      document_name: 'Field Call Instructions Combined',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'FCC_Instructions',
    },
    {
      document_id: '5',
      document_type_id: '1',
      document_name: 'Enforcement Hearing Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'EH_Instructions',
    },
    {
      document_id: '6',
      document_type_id: '1',
      document_name: 'Occupancy Check Intructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'OC_Instructions',
    },
    {
      document_id: '7',
      document_type_id: '1',
      document_name: 'Lockout Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'Lockout_Instructions',
    },
  ];
  subject_template_docs: any;
  sent_subject_job_type_id: any;
  sent_subject_com_type_id: any;
  model!: SubjectCommunication;
  created_file_name?: string;
  tableData?: any;
  tableSubjectData?: any;
  get_latest_subject_note_id?: any;
  job_types?: any;
  job_subject_types?: any;
  job_plaintiff_types?: any;
  job_type_locations?: any;
  count2?: any;
  job_type_courts?: any;
  sent_job_type_location_id?: any;
  job_type_document_types?: any;
  sent_job_type_court_id?: any;
  job_type_affidavit_types?: any;
  sent_job_type_document_type_id?: any;
  doc_check?: any = [];
  assignedList?: any;
  assignedBrandList?: any;

  subjectFullNameOrBusiness?: any;

  // iframe
  name = 'Set iframe source';
  url = 'https://angular.io/api/router/RouterLink';
  urlSafe?: SafeResourceUrl;
  job_data?: any;
  brand_data?: any;
  recipient_brand_id?: any;
  accounts_brand_id?: any;
  brand_account_data?: any;
  brand_user_data?: any;
  email_template_name?: any;
  html_data?: string;
  url_non_ssl?: string;
  recipient_report_id?: any;
  email_template_HTML?: any;
  brand_report_id?: any;
  brand_invoice_id?: any;
  primary_contacts?: any;
  filemodel!: SystemFile;
  file_created_response: any;
  sessionUserLevel: any;
  system_log_created_response?: any;
  file_edit_level?: string;
  returned_created_file_id?: any;
  subject_invoices?: any;
  current_invoice_id?: any;
  report_user_contacts?: any;
  brand_report_user_id?: any;
  DialogObj?: any;
  next_date?: any;
  final_date?: any;
  job_status_id?: any;
  legalDatePickerValues: { [field: string]: Date | null } = {};
  message_subject?: string;
  set_job_file?: number;
  set_subject_file?: number;
  allAgentRecipients?: any[];
  assignedAgentsList2?: any;
  sessionUsername?: any;
  sessionUserFullName?: string;
  sessionUserFirstName?: any;
  subject_number?: string;
  job_id: any;
  fileUploader: any;
  selectedFileBlob!: Blob;
  set_document_password: string;
  is_encrypted: number;


  public _http?: HttpClient;
  public _baseUrl?: string;





  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    vcr: ViewContainerRef,
    private router: Router,
    public HttpClient: HttpClient,
    // private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    private _location: Location,
    public sanitizer: DomSanitizer,
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService
  ) {


 //   this.gfunc.setLoginSessionVars(); // set in a global function file
    // this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    // this.sessionUsername = this.gfunc.currentUserVAR.username;
    // this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
    //     this.sessionUserLevel = this.gfunc.currentUserVAR.access_level;
    //     this.sessionUserFullName = this.gfunc.currentUserVAR.first_name + ' ' + this.gfunc.currentUserVAR.surname;
    //     this.sessionUserFirstName = this.gfunc.currentUserVAR.first_name;
  }

  ngOnInit(): void {

    this.username = 'my-text-control - TSA - tsa-textControlvBeta';

// comms
this.filemodel = new SystemFile();

this.modelds = new SubjectCommunicationAttatchments();
this.model = new SubjectCommunication();
this.legalDatePickerValues = {};
this.model.attached_file_name = '';

// this.subject_id = +this.route.snapshot.paramMap.get('subject_id');
this.subject_id = 517 // set for demo purposes
this.subject_number = '1126.2.1.1' // set for demo purposes


this.getJobSubject(this.subject_id);
this.getJobStatusNames();
this.getSubjectComTypes();
  }

  getLegalDatePickerValue(model: any, field: string): Date | null {
    return this.legalDatePickerValues[field] ?? this.legalDate.toPickerDate(model?.[field]);
  }

  onLegalDateChange(model: any, field: string, value: unknown): void {
    const pickerDate = this.legalDate.coercePickerDate(value);
    this.legalDatePickerValues[field] = pickerDate;
    model[field] = this.legalDate.fromPickerDate(pickerDate);
  }


// comms
getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
    (data) => {
      this.subjects = data;
      const res = data[0];
     // this.getSubjectNotes(res.subject_id);
      // load subject history
      // this.getSubjectProgress(res.job_id, res.file_number);

      // set the subject name
      if (res.business_name !== '' || res.business_name !== null) {
        this.subjectFullNameOrBusiness = res.business_name;
      }

      if (res.business_name === '' || res.business_name === null) {
        this.subjectFullNameOrBusiness = res.first_name + ' ' + res.surname;
      }

                this.job_id = res.job_id;
                this.subject_number = res.subject_number;

                this.next_date = res.next_date;
                this.final_date = res.final_date;
                this.job_status_id = res.job_status_id;

                this.refreshList(); // loads the file list (diretory)
                this.displaySubjectDocuments(this.subject_id, this.subject_number);

                this.getJobTypeLocations(res.job_type_id);
                this.getJobTypeCourts(res.job_type_location_id);
                this.getJobTypeDocumentTypes(res.job_type_court_id);
                this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
                this.getJobTypes();
                // this.getSubjectAgentBrandsAssigned(this.subject_id);

                // get the job data to get the brand to send to
                this.getJob(this.job_id);
                this.getSubjectInvoices(this.subject_id);



      // get job type in relation to subject
      // this.getJobType(res.job_type_id);
      // this.getJobTypeLocation(res.job_type_location_id);
      // this.getJobTypeCourt(res.job_type_court_id);
      // this.getJobTypeDocument(res.job_type_document_type_id);
      // this.getJobTypeAffidavit(res.job_type_affidavit_type_id)
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}
getSubjectInvoices(subject_id){
  this._demoService.getSubjectInvoices(subject_id).subscribe(
    data => {
      this.subject_invoices = data;
  let res = data[0];
  this.current_invoice_id = res.invoice_id;
     },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}
private displaySubjectFiles(data: any): void {
  this.tableSubjectData = data.json();
}
displaySubjectDocuments(subject_id, subject_number) {
  // this.fileUploader.getJobSubjectFiles(this.subject_id, this.subject_number)
    // .subscribe((res) => this.displaySubjectFiles(res));
}
private refreshList(): void {
  // notice the update here for traces
  // this.fileUploader.getJobFiles(this.job_id).subscribe((res) => this.displayTableData(res));
}

private displayTableData(data: any): void {
  this.tableData = data.json();
}
getSubjectNotes(subject_id) {
  this._demoService.getSubjectNotes(subject_id).subscribe(
    (data) => {
      this.subject_notes = data;
      // console.log("Done loadng USER");
      // console.log(this.users);
    },
    (error) => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
    }
  );
}

private getJobStatusNames() {
  this._demoService.getJobStatusNames().subscribe(
    (res) => (this.job_status_run = res),
    (err) => console.error(err.status)
  );
}

private getSubjectComTypes() {
  this._demoService.getSubjectComTypes().subscribe(
    (res) => (this.subject_com_types = res),
    (err) => console.error(err.status)
  );
}


// private getSubjectComTypes() {
//   this._demoService.getSubjectComTypes().subscribe(
//     (res) => (this.subject_com_types = res),
//     (err) => console.error(err.status)
//   );
// }

sendSubjectComTypeID(subject_com_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_subject_com_type_id = subject_com_type_id;
  this.getSubjectTemplateDocs(this.sent_subject_com_type_id); // updates the selected job ID....
  console.log(this.sent_subject_com_type_id);
}

public getSubjectTemplateDocs(subject_com_type_id) {
  this._demoService.getSubjectTemplateDocs(subject_com_type_id).subscribe(
    (res) => (this.subject_template_docs = res),
    (err) => console.error(err.status)
  );
}



  // Removes Email From Main List. (by ID's)

  RemoveElementFromAllEmailRecipients(key: number) {
    // removes agents
    this.allEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allEmailRecipients.splice(index, 1);
      }
    });
    // removes clients Report
    this.allClientEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allClientEmailRecipients.splice(index, 1);
      }
    });
    // removes clients Invoice
    this.allClientInvoiceEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allClientInvoiceEmailRecipients.splice(index, 1);
      }
    });
    // removes Login Users
    this.allLoginEmailRecipients.forEach((value, index) => {
      if (value.user_id === key) {
        this.allLoginEmailRecipients.splice(index, 1);
      }
    });

    // removes all attachments
  //   this.allAttachments.forEach((value, index) => {
  //     if (value.file_name === key) {
  //       this.allAttachments.splice(index, 1);
  //     }
  //   });
  // }

  // RemoveElementFromAllRecipients(key: number) {
  //   // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  //   this.allRecipients.forEach((value, index) => {
  //     if (value.recipient_name === key) {
  //       this.allRecipients.splice(index, 1);
  //     }
  //   });

      // :: Specifcally removes the array item without there being
      // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

  };


  // MODAL
  // start of modal windows service as a template
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// BOF SHARMANS CALLS
getJobTypes() {
  this._demoService.getJobTypes().subscribe(
    (data) => {
      this.job_types = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getJobSubjectTypes() {
  this._demoService.getJobSubjectTypes().subscribe(
    (data) => {
      this.job_subject_types = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getJobPlaintiffTypes() {
  this._demoService.getJobPlaintiffTypes().subscribe(
    (data) => {
      this.job_plaintiff_types = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getJobTypeLocations(job_type_id) {
  this._demoService.getJobTypeLocations(job_type_id).subscribe(
    (data) => {
      this.job_type_locations = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

sendJobTypeLocationsID(job_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count2 = job_type_id;
  this.getJobTypeLocations(this.count2); // updates the selected job ID....

  console.log('sending Count:' + this.count2);
}

getJobTypeCourts(job_type_location_id) {
  this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
    (data) => {
      this.job_type_courts = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

sendJobTypeCourtsID(job_type_location_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_location_id = job_type_location_id;
  this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....

  console.log('sending Location:' + this.sent_job_type_location_id);
}

getJobTypeDocumentTypes(job_type_court_id) {
  this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
    (data) => {
      this.job_type_document_types = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

sendJobTypeDocumentTypesID(job_type_court_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_court_id = job_type_court_id;
  this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....

  console.log('sending Court Type:' + this.sent_job_type_court_id);
}

getJobTypeAffidavitTypes(job_type_document_type_id) {
  this._demoService
    .getJobTypeAffidavitTypes(job_type_document_type_id)
    .subscribe(
      (data) => {
        this.job_type_affidavit_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
}

sendJobTypeAffidavitTypesID(job_type_document_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_document_type_id = job_type_document_type_id;
  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

  console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
}


        getSubjectTemplateDocsCheck(model) {
          this._demoService.getSubjectTemplateDocsCheck(model).subscribe(
            (data) => {
              {
                this.doc_check = data;
                const res = data[0];
                // set the model document id to the new one affidavits.
                model.doc_id = res.doc_id; // does this need to be this.???
                // set the recipeint type for display
                model.brand_type_id = res.brand_type_id;

                this.email_template_name = res.email_template;
                this.email_template_HTML = res.email_template_HTML;
                model.email_template_HTML = res.email_template_HTML;
                model.send_to_invoice = res.send_to_invoice;
                model.send_to_report = res.send_to_report;
                model.send_to_logins = res.send_to_logins;
                model.send_to_primary = res.send_to_primary;
                model.brand_type_id = res.brand_type_id;
                model.send_to_report_user = res.send_to_report_user;

                // load the recipients into an array
                this.getSubjectAgentBrandsAssigned(this.subject_id);
                // load brands - clients into array
                this.getBrand(this.recipient_report_id);
                this.getBrandUsers(this.recipient_report_id);
                this.getBrandAccount(this.accounts_brand_id);

                model.brand_report_id = this.brand_report_id;
                model.brand_invoice_id = this.brand_invoice_id;
                model.brand_report_user_id = this.brand_report_user_id;

                // had to set here to sho
                model.subject_id = this.subject_id;

                model.change_dates = '1'; // set to default to system dates changes
  // this.created_file_name = null; // reset the file to be recreated on change

                // Setup Recipients :: New 2022 Model allRecipients
// this.setAllRecipients(model);

                // :: Set the Message Subject Default Title
                // tslint:disable-next-line:max-line-length
                this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
                model.message_subject = this.message_subject;

                this.url =
                this.gfunc.baseUploadURLEmailTemplatesSSL +
                  this.email_template_name;
                this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
                  this.url
                );
              }
            },
            (err) => console.error(err)
            // () => console.log('done loading Trace Types')
          );
        }

// to router navigate back
public goBack() {
  this._location.back();
}

docView(doc_id) {
  this.router.navigate([
    '/admin/communication/com_type_template_doc_view/' + doc_id + '',
  ]);
}

docEdit(doc_id) {
  this.router.navigate([
    '/admin/communication/com_type_template_doc_edit/' + doc_id + '',
  ]);
}


docEditSubjectFile(file_id) {
  this.router.navigate(['/admin/jobs/subject/communication/docx-view/' + file_id + '']);
}

docViewSubjectFile(file_id) {
  this.router.navigate(['/admin/jobs/subject/communication/docx-view/' + file_id + '']);
}

viewSystemFile(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
}

editSystemFile(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
}

editDocFile(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
}


editDocxSystemFile(file_id) {
  this.gfunc.globalEditDocxSystemFile(file_id);
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
}



viewDocxSystemFile(file_id) {
  this.gfunc.globalViewDocxSystemFile(file_id);
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
}

getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
    (data) => {
      this.assignedBrandList = data;

      this.allEmailRecipients = data;

      // let newArr = data
      // let  count_of_items = Object.keys(newArr).length;
      //   // need to do a loop of subject_billing items (.length)
      //   for (let i = 0; i < count_of_items; i++) {
      //   let res = newArr[i];
      //   this.allRecipients.push({
      //     recipient_name: res.name + ' - Agent',
      //     recipient_email_address: res.email,
      //     recipient_brand_id: res.brand_id,
      //     recipient_brand_type_id: res.brand_type_id,
      //     recipient_user_id: null,
      //     recipient_user_level_id: null,
      //     recipient_type_name: 'Agent',
      //   });
      //   } // end for loop
      // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


    },
    (err) => console.error(err),
    // () => console.log('Loaded Assigned Agents Loaded.')
  );
}

getUrl(post, email_template) {
  return this.sanitizer.bypassSecurityTrustResourceUrl(
    'https://' + post + '/' + email_template
  );
}

// testing some jquery
Testing() {
  const name = (
    document.getElementById('subject_com_type_id') as HTMLTextAreaElement
  ).value;
  alert(name);

  // get the option name of the select Works so can use when adding as a fix.
  const conceptName = $('#subject_com_type_id').find(':selected').text();
  const conceptNameID = $('#subject_com_type_id').find(':selected').val();
  alert(conceptNameID + ':-  ' + conceptName);
}

private getBrand(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.brand_data = data;

      this.allClientEmailRecipients = data;

      // let newArr = data
      // let  count_of_items = Object.keys(newArr).length;
      //   // need to do a loop of subject_billing items (.length)
      //   for (let i = 0; i < count_of_items; i++) {
      //   let res = newArr[i];
      //   this.allRecipients.push({
      //     recipient_name: res.name + ' - Client Report',
      //     recipient_email_address: res.email,
      //     recipient_brand_id: res.brand_id,
      //     recipient_brand_type_id: res.brand_type_id,
      //     recipient_user_id: null,
      //     recipient_user_level_id: null,
      //     recipient_type_name: 'Client Report',
      //   });
      //   } // end for loop
      // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}

private getBrandAccount(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.brand_account_data = data;

      this.allClientInvoiceEmailRecipients = data;


      // let newArr = data
      // let  count_of_items = Object.keys(newArr).length;
      //   // need to do a loop of subject_billing items (.length)
      //   for (let i = 0; i < count_of_items; i++) {
      //   let res = newArr[i];
      //   this.allRecipients.push({
      //     recipient_name: res.name + ' - Client Accounts',
      //     recipient_email_address: res.email,
      //     recipient_brand_id: res.brand_id,
      //     recipient_brand_type_id: res.brand_type_id,
      //     recipient_user_id: null,
      //     recipient_user_level_id: null,
      //     recipient_type_name: 'Client Accounts',
      //   });
      //   } // end for loop
      // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}

getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
    (data) => {
      this.brand_user_data = data;

      this.allLoginEmailRecipients = data;

      // let newArr = data
      // let  count_of_items = Object.keys(newArr).length;
      //   // need to do a loop of subject_billing items (.length)
      //   for (let i = 0; i < count_of_items; i++) {
      //   let res = newArr[i];
      //   this.allRecipients.push({
      //     recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
      //     recipient_email_address: res.email_address,
      //     recipient_brand_id: null,
      //     recipient_brand_type_id: null,
      //     recipient_user_id: res.user_id,
      //     recipient_user_level_id: res.access_level,
      //     recipient_type_name: 'Client User',
      //   });
      //   } // end for loop
      // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

    },
    (err) => console.error(err),
    () => console.log('Candidates Loaded.')
  );
}

// get job
getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
    (data) => {
      this.job_data = data;
      let res = data[0];
      // lookup the brand to get the contact details to send to
      this.recipient_brand_id = res.brand_report_id;
      this.recipient_report_id = res.brand_report_id;
      this.accounts_brand_id = res.brand_invoice_id;
      this.getBrand(res.brand_report_id);
      this.getBrandAccount(res.brand_invoice_id);
      this.getBrandUsers(res.brand_report_id);
      this.getBrandPrimaryContact(this.recipient_report_id);
      this.getJobReportUserContact(res.brand_report_user_id);

      this.brand_report_id = res.brand_report_id;
      this.brand_invoice_id = res.brand_invoice_id;
      this.brand_report_user_id = res.brand_report_user_id;

      // this.next_date = res.next_date;
      // this.final_date = res.final_date;
      // this.job_stati

      //this.model.brand_id = this.recipient_brand_id;
      ///console.log('check brand' + this.recipient_brand_id);
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}



  // need to get user details
  getBrandPrimaryContact(brand_id) {
    this._demoService.getBrandPrimaryContact(brand_id).subscribe(
       data => { this.primary_contacts = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.first_name +  ' ' + res.surname + ' - Primary Contact',
        //     recipient_email_address: res.email_address,
        //     recipient_brand_id: null,
        //     recipient_brand_type_id: null,
        //     recipient_user_id: res.user_id,
        //     recipient_user_level_id: res.access_level,
        //     recipient_type_name: 'Primary Contact',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



  // need to get user details
  getJobReportUserContact(brand_report_user_id) {
    this._demoService.getUsersById(brand_report_user_id).subscribe(
       data => { this.report_user_contacts = data;
        //  let res = data[0];
  // Run the job data queries.
        // :: Impliments automatic recipients based on chosen com template options (Moved and recoded into a seeperate function)
        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
        //     recipient_email_address: res.email_address,
        //     recipient_brand_id: null,
        //     recipient_brand_type_id: null,
        //     recipient_user_id: res.user_id,
        //     recipient_user_level_id: res.access_level,
        //     recipient_type_name: 'Client Report User',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }





  // lookup and then set the doc_check array with the data.
  getSubjectTemplateDoc(model) {
    this._demoService.getSubjectTemplateDoc(model.doc_id).subscribe(
      (data) => {
        this.doc_check = data;
        const res = data[0];
        // load the drop downs res.doc_ii
        // set the model document id to the new one affidavits.
        model.doc_id = res.doc_id;
        // set the recipeint type for display
        model.brand_type_id = res.brand_type_id;
        this.email_template_name = res.email_template;
        this.email_template_HTML = res.email_template_HTML;
        model.email_template_HTML = res.email_template_HTML;
        model.send_to_invoice = res.send_to_invoice;
        model.send_to_report = res.send_to_report;
        model.send_to_logins = res.send_to_logins;
        model.send_to_primary = res.send_to_primary;
        model.brand_type_id = res.brand_type_id;
        model.send_to_report_user = res.send_to_report_user;

        model.brand_report_id = this.brand_report_id;
        model.brand_invoice_id = this.brand_invoice_id;
        model.brand_report_user_id = this.brand_report_user_id;
        model.subject_id = this.subject_id;

        // load the recipents into an array
        this.getSubjectAgentBrandsAssigned(this.subject_id);
        // load brands - clients into array
        this.getBrand(this.recipient_report_id);
        this.getBrandUsers(this.recipient_report_id);
        this.getBrandAccount(this.accounts_brand_id);

        model.change_dates = '1'; // set to default to system dates changes -- Auust Users must now use dates!
        this.created_file_name = ''; // reset the file to be recreated on change
        // iframe

        // Setup Recipients :: New 2022 Model allRecipients
        this.setAllRecipients(model);

         // tslint:disable-next-line:max-line-length
         this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
         model.message_subject = this.message_subject;

        this.url =
        this.gfunc.baseUploadURLEmailTemplatesSSL +
          this.email_template_name;
        this.url_non_ssl =
        this.gfunc.baseUploadURLEmailTemplates +
          this.email_template_name;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);

        //   This DID NOT WORK!  CORS ACCESS ISSUES (will only work online? no cors)
        // HAD TO SETUP SERVER TO ALLOW ACCESS PLESK
        // see:  https://support.plesk.com/hc/en-us/articles/115001338265-How-to-set-up-CORS-cross-origin-resource-sharing-in-Plesk-for-Linux-

        //   if(this.email_template_name != null) {
        //   // get email temlate file as a variable TESTING
        //   fetch(this.url)
        //   .then(response => response.text())
        //   .then(html_data => {
        //   	// Do something with your data
        //     this.html_data = html_data;
        //   	console.log(html_data);
        //   });
        //   // end fetch
        // } // end if no template set
      },
      (err) => console.error(err),
      () => console.log('')
    );
  }










  // :: Method to all default recipients
  setAllRecipients(model) {
    this.allRecipients = []

  if (model.send_to_report == 1) {
    //
          // :: Impliments automatic recipients based on chosen com template options
          // :: Subract Method / Filter
          // :: DEMOSERVICE look up client brand details.
          this._demoService.getBrandById(model.brand_report_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Report',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Report',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Report Recipient Added.')
          );

      } // end if send_to_report

      // AGENT
      if ( model.brand_type_id == 3) {
        this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
               recipient_name: res.name + ' - Agent',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Agent',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Agent Recipients Added.')
        );
        // const key = 'Agent';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Agent Recipients');
        //   }
        // });
      };

      if (model.send_to_report_user == 1) {

        this._demoService.getUsersById(model.brand_report_user_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client Report User',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client Report User Recipient Added.')
        );
        // const key = 'Client Report User';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Report User Recipient');
        //   }
        // });
      };

      if (model.send_to_invoice == 1) {
          this._demoService.getBrandById(model.brand_invoice_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Accounts',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Accounts',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Accounts Recipient Added.')
          );
      }

      if (model.send_to_logins == 1) {
        this._demoService.getBrandUsers(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client User',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client User Recipient Added.')
        );
        // const key = 'Client User';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Client User Recipients');
        //   }
        // });
      }

      if (model.send_to_primary == 1) {
        this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client Primary Contact',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client Primary Contact Added.')
        );


        // const key = 'Primary Contact';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Primary Contact Recipient');
        //   }
        // });
      }

} // end function









// txc




  openDocument(e: any) {
    this.readDocument(e);
    TXTextControl.enableCommands();

    TXTextControl.addEventListener("textFieldEntered", function(e: any) {
      // TXTextControl.sendCommand(
      //   TXTextControl.Command.EditMode,
      //   TXTextControl.EditMode.Edit
      // );
    });

    TXTextControl.addEventListener("textFieldLeft", function(e: any) {
      // TXTextControl.sendCommand(
      //   TXTextControl.Command.EditMode,
      //   TXTextControl.EditMode.ReadAndSelect
      // );
    });
  }








 // :: Loads a file directory from the server ()
 public loadServerFileDirectTxc(filename) {

  if (filename == undefined){filename = 'QCATSubServOccupant.docx'}; // set something
  this.http.get(this.gfunc.baseUploadURL_SSL + '/' + filename, { responseType: 'blob' }).subscribe(data => {
  //  console.log('data2 on import...', data);
    this.selectedFileBlob = data;
    // var encoded = btoa(data); // btoa base-64-encodes strings.
    TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML, data);

    // let sfdt: string = data;
    // this.container.documentEditor.open(sfdt);
    // this.container.documentEditor.open(this.selectedFileBlob);
    // this.toastr.success('Template Loaded in Editor - Directly');
   // this.model.newTemplateFileName = this.selectedFileData;
    //
  });


};


 // :: Loads a file directory from the server ()
 public loadServerFileDirectTxc_LOCAL(filename) {
  filename = 'ACTMagistratesCourtAffidavit_Order_MagistratesCourt.docx'
  if (filename == undefined){filename = 'QCATSubServOccupant.docx'}; // set something
  this.http.get('http://localhost/WordTemplates/' + filename, { responseType: 'blob' }).subscribe(data => {
  //  console.log('data2 on import...', data);
    this.selectedFileBlob = data;
    // var encoded = btoa(data); // btoa base-64-encodes strings.
    TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML, data);

    // let sfdt: string = data;
    // this.container.documentEditor.open(sfdt);
    // this.container.documentEditor.open(this.selectedFileBlob);
    // this.toastr.success('Template Loaded in Editor - Directly');
   // this.model.newTemplateFileName = this.selectedFileData;
    //
  });


};






 loadTxcDocument(doc_id) {
    // this.router.navigate([
    //   '/admin/communication/com_type_template_doc_view/' + doc_id + '',
    // ]);
var FileToload = "https://tsa.backvault.com.au/APP_PHP/WordTemplates/QCATAOSForm9Vers4-2.docx" as string;
var encoded = btoa(FileToload); // btoa base-64-encodes strings.
TXTextControl.loadDocument('WordprocessingML', FileToload);
TXTextControl.sendCommand(
 TXTextControl.Command.EditMode,
 // TXTextControl.EditMode.ReadAndSelect
 TXTextControl.EditMode.Edit
);

  }

  // goal is to create a direct link first and and load a file from the server diretly - simples
  // then code the rest in with the drop downs - to load the file after the drop downs selected
  // then work out how to save the file back to the server, after edit, - like create document function, except it just saves the file to the location and
  // .. the rest of the normal commnmands

  // bata bing bata boom... and the prototype is done and working

  // - Setup all Vars to be accessible in model, and merge
  // work out if empty errors - that is if a variable does not exists on the page... creates js errors.
  // - loop and merges and headers
  // - themes and backgrounds and do we need them any more.
  // then setup a a system to create / edit the templates / themes / merges


  readDocument(input: any) {
    if (input.target.files && input.target.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        var streamType = TXTextControl.streamType.PlainText;

        // set the StreamType based on the lower case extension
        switch (
          input.target.value
            .split(".")
            .pop()
            .toLowerCase()
        ) {
          case "doc":
            streamType = TXTextControl.streamType.MSWord;
            break;
          case "docx":
            streamType = TXTextControl.streamType.WordprocessingML;
            break;
          case "rtf":
            streamType = TXTextControl.streamType.RichTextFormat;
            break;
          case "htm":
            streamType = TXTextControl.streamType.HTMLFormat;
            break;
          case "tx":
            streamType = TXTextControl.streamType.InternalUnicodeFormat;
            break;
          case "pdf":
            streamType = TXTextControl.streamType.AdobePDF;
            break;
        }

        // load the document beginning at the Base64 data (split at comma)
        TXTextControl.loadDocument(streamType, e.target.result.split(",")[1]);
         TXTextControl.sendCommand(
          TXTextControl.Command.EditMode,
          // TXTextControl.EditMode.ReadAndSelect
          TXTextControl.EditMode.Edit
        );

      };

      // read the file and convert it to Base64
      fileReader.readAsDataURL(input.target.files[0]);
    }
  }


// this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
  async setInputs(item: any, placeholder:any) {
    await new Promise(resolve => {
      item.find(`{{${placeholder}}}`, 0, 0, (r: any) => {
            console.log(r);
            TXTextControl.selection.setText("");
            TXTextControl.selection.setStart(r, () => {
            TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
                this.isUserNameFieldExist = true;
                f.setText(this[placeholder]);
                f.setName(placeholder);
                resolve(placeholder);
            });
            });
          });
    })

  }

  async setViewerInputs(item: any, placeholder: any) {
    await new Promise(resolve => {
      item.find(`{{${placeholder}}}`, 0, 0, (r: any) => {
            TXTextControl.selection.setText(this[item]);
            resolve("done")
          });
    })

  }


  mailMerge(){
    // TXTextControl.Load("template.tx", TXTextControl.StreamType.InternalUnicodeFormat);
    // const data = System.IO.File.ReadAllText("data.json");

    // using (TXTextControl.DocumentServer.MailMerge mailMerge =
    //        new TXTextControl.DocumentServer.MailMerge())
    // {
    //     mailMerge.TextComponent = textControl1;
    //     mailMerge.MergeJsonData(data);
    // }










  }


  bindViewer() {
    TXTextControl.textParts.forEach( async(item: any, i: any) => {
     if (item.find && i === 0) {
       for (let i=0; i<this.placeholders.length; i++) {
         await  this.setViewerInputs(item, this.placeholders[i]);
       }
     }
   });
 }

 bind() {

   TXTextControl.textParts.forEach( async(item: any, i: any) => {
     if (item.find && i === 0) {
       for (let i=0; i<this.placeholders.length; i++) {
         await  this.setInputs(item, this.placeholders[i]);
       }

       this.editor = true;
     }
   });

   // TXTextControl.getSubTextParts(function(r) {
   //   console.log(r)
   // })

   // TXTextControl.getTextParts(function(r) {
   //   console.log(r)
   // })

   // TXTextControl.getText(function(r) {
   //   console.log(r)
   // })
 }





// TSA

 bindTsaVars() {
  TXTextControl.textParts.forEach( async(item: any, i: any) => {
    if (item.find && i === 0) {
      for (let i=0; i<this.placeholders.length; i++) {
        await  this.setInputsTsaVars(item, this.placeholders[i]);
      }

      this.editor = true;
    }
  });

  // TXTextControl.getSubTextParts(function(r) {
  //   console.log(r)
  // })

  // TXTextControl.getTextParts(function(r) {
  //   console.log(r)
  // })

  // TXTextControl.getText(function(r) {
  //   console.log(r)
  // })
}


// :: WORKING VARS REPLACEMENT WORKING --
// this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
async setInputsTsaVars(item: any, placeholder:any) {
  await new Promise(resolve => {
    item.find( '$' + `{${placeholder}}`, 0, 0, (r: any) => {
          console.log(r);
          TXTextControl.selection.setText("");
          TXTextControl.selection.setStart(r, () => {
          TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
              this.isUserNameFieldExist = true;
              f.setText(this[placeholder]);
              f.setName(placeholder);
              resolve(placeholder);
          });
          });
        });
  })

}

// BKUP working version below.

      // // this is how I can run over my template variables live.... ( just setup my new biding code and we can see it run live.... and then simply edit and save all in one step!!!!!!)
      // async setInputsTsaVars(item: any, placeholder:any) {
      //   await new Promise(resolve => {
      //     item.find( `{{${placeholder}}}`, 0, 0, (r: any) => {
      //           console.log(r);
      //           TXTextControl.selection.setText("");
      //           TXTextControl.selection.setStart(r, () => {
      //           TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any[]) => void; setName: (arg0: any) => void; }) => {
      //               this.isUserNameFieldExist = true;
      //               f.setText(this[placeholder]);
      //               f.setName(placeholder);
      //               resolve(placeholder);
      //           });
      //           });
      //         });
      //   })

      // }



 onClickSave(prop: any) {
  const source = fromEvent(TXTextControl, "textFieldChanged");
  source.subscribe((f: any) => {
    // if(f.textField.name === 'username') {
    //   this.username = f.textField.text;
    // }

    console.log("changes");
  });

  if (!this.isUserNameFieldExist) {
    TXTextControl.formFields.addTextFormField(1000, (f: { setText: (arg0: any) => void; setName: (arg0: any) => void; }) => {
      this.isUserNameFieldExist = true;
      f.setText(prop);
      f.setName(prop);
    });
  } else {
    TXTextControl.formFields.forEach((formField: { getName: (arg0: (formFieldName: any) => void) => void; setText: (arg0: any) => void; }) => {
      formField.getName((formFieldName: any) => {
        if (formFieldName === prop) {
          formField.setText(prop);
        }
      });
    });
  }
}



// I need three apps built custom to make this work.
saveDocument_Base() {
  TXTextControl.saveDocument(TXTextControl.StreamType.HTMLFormat,
      function (e:any) {
          console.log(e.data);
          console.log('This is saving........ This is where the Node. Js');
          alert('now need to build a node js app to do the websocket to talk to the API backend TCP service.')
      });
}



saveDocumentAsAdobePDF(){

      // save the document as PDF
      TXTextControl.saveDocument(TXTextControl.StreamType.AdobePDF, function (e:any) {
        let bDocument = e.data;
        // create temporary link to download document
        var element = document.createElement('a');
        element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
        element.setAttribute('download', "results.pdf");

        element.style.display = 'none';
        document.body.appendChild(element);

        // simulate click
        element.click();

        // remove the link
        document.body.removeChild(element);
        });

}


saveDocumentAsWordprocessingML(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.WordprocessingML, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.docx");

    element.style.display = 'none';
    document.body.appendChild(element);

    // simulate click
    element.click();

    // remove the link
    document.body.removeChild(element);
    });

}


saveDocumentAsMSWord(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.MSWord, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.doc");

    element.style.display = 'none';
    document.body.appendChild(element);

    // simulate click
    element.click();

    // remove the link
    document.body.removeChild(element);
    });

}



saveDocumentAsHTMLFormat(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.HTMLFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.html");

    element.style.display = 'none';
    document.body.appendChild(element);

    // simulate click
    element.click();

    // remove the link
    document.body.removeChild(element);
    });

}



saveDocumentAsSpreadsheetMLt(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.SpreadsheetML, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.xml");

    element.style.display = 'none';
    document.body.appendChild(element);

    // simulate click
    element.click();

    // remove the link
    document.body.removeChild(element);
    });

}



saveDocumentAsRichTextFormat(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.RichTextFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.rtf");

    element.style.display = 'none';
    document.body.appendChild(element);

    // simulate click
    element.click();

    // remove the link
    document.body.removeChild(element);
    });

}


saveDocumentAsPlainText(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.PlainText, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.txt");

    element.style.display = 'none';
    document.body.appendChild(element);

    // simulate click
    element.click();

    // remove the link
    document.body.removeChild(element);
    });

}



saveDocumentAsInternalUnicodeFormat(){

  // save the document as PDF
  TXTextControl.saveDocument(TXTextControl.StreamType.InternalUnicodeFormat, function (e:any) {
    let bDocument = e.data;
    // create temporary link to download document
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
    element.setAttribute('download', "results.xlxs");

    element.style.display = 'none';
    document.body.appendChild(element);

    // simulate click
    element.click();

    // remove the link
    document.body.removeChild(element);
    });

}


// need api to - does note work with current setuo may with server tiw ill

async onClickLoadDocument() {
  // get a document from the Web API endpoint 'LoadDocument'
  this.HttpClient.get<any>(this._baseUrl + 'api/viewer/loaddocument').subscribe(result => {
    loadDocument(result);
  }, error => console.error(error));
}












// create angular document
// need to get the file id from the response
createDocument(model) {
  // this._mysqlService.createDocument(model).subscribe(
   this._mysqlService. createDocument_2021Test(model).subscribe(
  (data) => {
       // this.trace_candidate_update = data;
      //  this.toastr.success('Creating Document for you now.');
       const res = data;
       console.log(res); // not working as response is showing in body
       // console.log(res._body);
       console.log(res[0].text()); // Convert response to a string
       this.created_file_name = res[0].text();
       model.attached_file_name = this.created_file_name;
       this.refreshList(); // loads the file list (diretory)
       this.displaySubjectDocuments(this.subject_id, this.subject_number);

       // push to global array
       this.allAttachedFiles.push(this.created_file_name);

       // Start the new array of file
       // this.allAttachments.push(this.created_file_name);

       const pushed_file = {
         file_name: this.created_file_name,
         subject_file: 1,
         job_file: 0,
       }; // multidimentional array push
       // this.allAttachments.push(pushed_file); // old way only works for an array.

       // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
       // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
       this.allAttachments.push({
         file_name: this.created_file_name,
         job_file: 0,
         subject_file: 1,
       });
       model.allAttachments = this.allAttachments; // ?? this may be causing errors.

       // [{name: currencyName, amount: this.ticker[currencyName].last} ]

       // Set the file locations
       // agent


     // set the agent permissions
     model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);


       if (model.brand_type_id === '3') {
       this.file_edit_level = '5'; // agent can edit
       }
       // client
       if (model.brand_type_id === '2') {
         this.file_edit_level = '3'; // client cannot edit  (staff member can)
       }

       const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
       const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
       const file_folder = this.gfunc.fileFolderDocs + model.subject_number;

       // const file_folder = '/APP_PHP/assets/docs/' + model.subject_number;
       const file_name = this.created_file_name?.slice(0, -5); // removes the extension
       const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
       // UPGRADE Document Model (Insert the File into the database)
       // File Json
       const create_file = {
         file_name: file_name,
         file_display_name: file_name,
         file_ext: 'docx',
         file_server_location: file_server_location,
         file_url: file_url,
         file_folder: file_folder,
         file_make: 'created', // automated / updated / created / uploaded / link_created
         file_notes: 'File created via subject communcation UI',
         file_job_id: this.job_id,
         file_subject_id: this.subject_id,
         file_subject_number: this.subject_number,
         created_by: this.sessionUserId,
         created_date: this.today,
         created_level: this.sessionUserLevel,
         file_brand_id: model.brand_report_id,
         file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
         is_active: '1',
         file_password: '',
         file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
         updated_by: '',
         updated_date: '',
         prev_file_id: '0',    // if updating
         brand_type_id: model.brand_type_id,  // if an agent or a client file
         subject_template_doc_id: model.doc_id,
         subject_com_type_id: model.subject_com_type_id,
         random_file_name: random_file_name,
         full_file_name: this.created_file_name,
         job_id: this.job_id,
         file_number: model.file_number,
         file_reference_number: model.file_reference_number,
         // arrays of sending to - based on subject_template_doc - setup
         agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
         report_access_array: JSON.stringify(this.brand_data), // collect client
         invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
         user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
         is_theme: model.is_theme,
         assigned_to_agents: model.assigned_to_agents
       };
      // console.log( (JSON.stringify(this.assignedBrandList)) );
       this.createFile(create_file);

       // const log_content
       // const log_action
       // Access DOM and get values from HTML template to send to logs
      // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
     // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value;
     // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
     // get the drop down value of text not id.



     },
     (error) => {
      //  this.toastr.error('Error Creating Document');
      //  return Observable.throw(error);
      console.log(error)
     }
   );
 }


// Created to test and process new paragraph templates/merge variables Live without effecting original and current systems and workflows Live.
createDocument_2023_Paragraphs(model, mergeJobData,invoice_id) {
  // generate more data first



  this._mysqlService.createDocument_2023_Paragraphs(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log('TheRespose: ' + res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);

// october need to fix this here?
        this.set_document_password = res[1] as string;
        console.log('set_document_password: ' + this.set_document_password);

        if(model.encrypt_file == true){
          this.is_encrypted = 1; //  encrypted
        }else{
          this.is_encrypted = 0; // no encrypted
        }

      // push to global array
      this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name); 
      
      
      // set the agent permissions
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      //report_access_array ??
      // if an agent the agent has to be the file_brand_id.
      // need to show the agent_id here! name here // model.brand_report_id
    model.brand_report_id = null;
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

                          const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
                          const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_name = this.created_file_name.slice(0, -5); // removes the extension
                          const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
                          // UPGRADE Document Model (Insert the File into the database)
                          // File Json
                          const create_file = {
                            file_name: file_name,
                            file_display_name: file_name,
                            file_ext: 'docx',
                            file_server_location: file_server_location,
                            file_url: file_url,
                            file_folder: file_folder,
                            file_make: 'created', // automated / updated / created / uploaded / link_created
                            file_notes: 'File created via subject communcation UI',
                            file_job_id: this.job_id,
                            file_subject_id: this.subject_id,
                            file_subject_number: this.subject_number,
                            created_by: this.sessionUserId,
                            created_date: this.today,
                            created_level: this.sessionUserLevel,
                            file_brand_id: model.brand_report_id,
                            file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                            is_active: '1',
                            file_password: this.set_document_password,
                            file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                            updated_by: '',
                            updated_date: '',
                            prev_file_id: '0',    // if updating
                            brand_type_id: model.brand_type_id,  // if an agent or a client file
                            subject_template_doc_id: model.doc_id,
                            subject_com_type_id: model.subject_com_type_id,
                            random_file_name: random_file_name,
                            full_file_name: this.created_file_name,
                            job_id: this.job_id,
                            file_number: model.file_number,
                            file_reference_number: model.file_reference_number,
                            // arrays of sending to - based on subject_template_doc - setup
                            agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                            report_access_array: JSON.stringify(this.brand_data), // collect client
                            invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                            user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                            is_theme: model.is_theme,
                            assigned_to_agents:  model.assigned_to_agents,  // set the agent permissions
                            is_encrypted: this.is_encrypted
                          };
                         // console.log( (JSON.stringify(this.assignedBrandList)) );
                          this.createFile(create_file);

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      // this.toastr.error('Error Creating Document');
            // console.log('there was an error' + JSON.stringify(error));
            // console.log('TextError.error: = ' + JSON.stringify(error.error.text));
            // this.created_file_name = error.error.text
      this.newCreatedFile(model, this.created_file_name);
    //  return error.error;
    },
     () => console.log('What do we do next..????' + this.created_file_name)
  );
}


// new with re response code being an error but returns and creatd the file... go fugure.???
newCreatedFile(model, created_file_name){


  model.attached_file_name = this.created_file_name;
  this.refreshList(); // loads the file list (diretory)
  this.displaySubjectDocuments(this.subject_id, this.subject_number);

  // push to global array
  this.allAttachedFiles.push(this.created_file_name);

  // Start the new array of file
  // this.allAttachments.push(this.created_file_name); 
  
  
  // set the agent permissions
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

  const pushed_file = {
    file_name: this.created_file_name,
    subject_file: 1,
    job_file: 0,
  }; // multidimentional array push
  // this.allAttachments.push(pushed_file); // old way only works for an array.

  // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  this.allAttachments.push({
    file_name: this.created_file_name,
    job_file: 0,
    subject_file: 1,
  });
  model.allAttachments = this.allAttachments; // ?? this may be causing errors.

  // [{name: currencyName, amount: this.ticker[currencyName].last} ]

  // Set the file locations
  //agent
 
  if (model.brand_type_id === '3') {
  this.file_edit_level = '5'; // agent can edit
  }
  //client
  if (model.brand_type_id === '2') {
    this.file_edit_level = '3'; // client cannot edit  (staff member can)
  }

                      const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
                      const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
                      const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
                      const file_name = this.created_file_name.slice(0, -5); // removes the extension
                      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
                      // UPGRADE Document Model (Insert the File into the database)
                      // File Json
                      const create_file = {
                        file_name: file_name,
                        file_display_name: file_name,
                        file_ext: 'docx',
                        file_server_location: file_server_location,
                        file_url: file_url,
                        file_folder: file_folder,
                        file_make: 'created', // automated / updated / created / uploaded / link_created
                        file_notes: 'File created via subject communcation UI',
                        file_job_id: this.job_id,
                        file_subject_id: this.subject_id,
                        file_subject_number: this.subject_number,
                        created_by: this.sessionUserId,
                        created_date: this.today,
                        created_level: this.sessionUserLevel,
                        file_brand_id: model.brand_report_id,
                        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                        is_active: '1',
                        file_password: '',
                        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                        updated_by: '',
                        updated_date: '',
                        prev_file_id: '0',    // if updating
                        brand_type_id: model.brand_type_id,  // if an agent or a client file
                        subject_template_doc_id: model.doc_id,
                        subject_com_type_id: model.subject_com_type_id,
                        random_file_name: random_file_name,
                        full_file_name: this.created_file_name,
                        job_id: this.job_id,
                        file_number: model.file_number,
                        file_reference_number: model.file_reference_number,
                        // arrays of sending to - based on subject_template_doc - setup
                        agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                        report_access_array: JSON.stringify(this.brand_data), // collect client
                        invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                        user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                        is_theme: model.is_theme,
                        assigned_to_agents:  model.assigned_to_agents  // set the agent permissions
                      };
                     // console.log( (JSON.stringify(this.assignedBrandList)) );
                      this.createFile(create_file);
}


 createFile(model){
  this._demoService.createFile(model).subscribe(
    data => { this.file_created_response = data;
    // need to get the returned ID to send to log create action

    this.returned_created_file_id = this.file_created_response.last_insert_id;
    console.log(this.returned_created_file_id);


    const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
    console.log('Communication Type Task: ' +  subject_com_type_name);
        //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
         //  console.log('Communication Type Task: ' +  subject_com_type_name);

        //  const doc_name = 'FIXMEPLEASE';
  var document;
   var doc_name2 = document.getElementById('doc_name').innerText;
   console.log('Document Name: ' +  doc_name2);


   const log_action = 'created';
   const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name2 + '';

           const create_sys_log = {
             log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
             log_action: log_action, // automated / updated / created / uploaded / link_created / sent
             created_by: this.sessionUserId,
             created_date: this.today,
             subject_id: this.subject_id,
             job_id: this.job_id,
             job_reference_number: model.job_reference_number,
             file_number: model.file_number,
             reference_number: model.job_reference_number,
             subject_number: model.subject_number,
             log_type_id: '1', // see datatable system_log_types
             created_level: this.sessionUserLevel,
             brand_type_id: model.brand_type_id,
             subject_com_type_id: model.subject_com_type_id,
             subject_template_doc_id: model.doc_id,
             log_name: log_name + ' - ' + this.returned_created_file_id,
             file_id: this.returned_created_file_id,
             invoice_id: model.invoice_id,
           };
          //  this.createSystemLog(create_sys_log);


    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}








}
